import { render, staticRenderFns } from "./CultureAssetMaintainAudit.vue?vue&type=template&id=06b83231&scoped=true&"
import script from "./CultureAssetMaintainAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAssetMaintainAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b83231",
  null
  
)

export default component.exports